import styled from "styled-components";

const BlueOnBlueLabel = styled.span`
    margin: 0;
    color: blue;
    font-weight: 400;
    background-color: rgb(217,219,252);
    padding: 2px 15px;
    border-radius: 20px;
    font-size: 14px;
`;

export default BlueOnBlueLabel;